export default "__VITE_ASSET__CTqa8D7c__"